import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import { TableRow, TableCell } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { Domain } from '@material-ui/icons';
import grey from '@material-ui/core/colors/grey';

import ResourceIcon from '../resources/ResourceIcon';

import PaginatedList from '../PaginatedList';
import ResourceValue from '../resources/ResourceValue';
import { FormattedMessage } from 'react-intl';

const styles = theme => ({
  form: theme.form,
  tools: {
    textAlign: "right"
  },
  largeCell: {
    width: 200
  },
  iconButton: {
    color: grey[600],
  },
  full: {
    overflow: 'auto',
  }
});

/**
 * List of users (or licences) in a subscription
 * Allows to remove users from subscriptions
 */

class UserList extends Component {

  render() {
    const {
      subscription,
      pagination,
      classes,
      handleLoadPage,
      handleRemoveUser,
      handleAddUser,
    } = this.props;

    const displayableResources = subscription.resources 
      ? subscription.resources.filter(resource => resource.id !== 'owners')
      : [];

    const domainInvitationsCount = subscription.domainInvitationsCount;

    let columns = [];
    
    if (domainInvitationsCount >= 1) {
      columns = [
        <FormattedMessage id='subscription.users.column.name' />,
        <FormattedMessage id='subscription.users.column.email' />, 
        <FormattedMessage id='subscription.users.column.host' />,
      ].concat(
        displayableResources.map(resource => 
          <ResourceIcon resource={resource} />,
        )
      )
    } else {
      columns = [
        <FormattedMessage id='subscription.users.column.name' />,
        <FormattedMessage id='subscription.users.column.email' />, 
      ].concat(
        displayableResources.map(resource => 
          <ResourceIcon resource={resource} />,
        )
      )
    }

    return (
        <Card className={classes.full}>
          <PaginatedList
            changeKey={subscription.id}
            pagination={pagination}
            isUser={true}
            owner={subscription.owner}
            subscription={subscription}
            noItem={
              <Typography variant="caption" align="center">
                <FormattedMessage id='subscription.users.info.noUser' />
              </Typography>
            }
            handleLoadPage={handleLoadPage}
            handleRemove={handleRemoveUser}
            handleAdd={handleAddUser}
            confirmTitle={<FormattedMessage id="subscription.users.confirmation.removeUser.title" />}
            confirmMessage={<FormattedMessage id="subscription.users.confirmation.removeUser" />}
            columns={[
              ...columns,
              "" 
            ]}
            Row={(user, deleteButton) => {
                  const resourcesById = user.resources.reduce((memo, resource) => ({
                    ...memo,
                    [resource.id]: resource
                  }), {});

                  return (
                    <TableRow key={user.id}>
                      <TableCell className={classes.largeCell}>
                        {user.firstName} {user.lastName}
                      </TableCell>
                      <TableCell>
                        {user.email}
                      </TableCell>
                      {
                        domainInvitationsCount >= 1?
                          <TableCell >
                            {user.isFromDomainInvitation? <Domain className={classes.iconButton} /> : null}
                          </TableCell>
                          : null
                      }
                      {displayableResources.map(({id}) => {
                        const resource = resourcesById[id];
                        if( resource ){
                          return (
                            <TableCell key={id}>
                              <ResourceValue resource={resource} displayValue displayUnit />
                            </TableCell>
                            )
                        }
                        return null;
                      })}
                      {deleteButton}
                </TableRow>
              )
            }}
          />
        </Card>
    )
  }
}

UserList.propTypes = {
  pagination: PropTypes.object,
  classes: PropTypes.object.isRequired,
  handleLoadPage: PropTypes.func.isRequired,
  handleRemoveUser: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
}

export default withStyles(styles)(
  UserList
);


// WEBPACK FOOTER //
// ./src/components/subscriptions/UserList.js